import { ActionTypes } from "./actions";
import { defaultState, bindReducers } from "src/utils/genState";
import createReducer from "src/utils/reduxsauce/createReducer";

const initialState = {
  ...defaultState(
    "tmrs",
    {
      metadata: undefined,
      selectedTmr: undefined,
      openDialog: false,
      openDeleteDialog: false,
    },
    []
  ),
};

const tmrCreatedSuccess = (state, draft, payload) => {
  const tmrs = state.tmrs || [];
  draft.tmrs = [...tmrs, payload];

  draft.openDialog = false;
};

const tmrDeleteSuccess = (state, draft, payload) => {
  const tmrs = state.tmrs || [];
  draft.tmrs = tmrs.filter((a) => a.id != payload.id);
  draft.openDeleteDialog = false;
};

const tmrEditedSuccess = (state, draft, payload) => {
  const tmrs = state.tmrs || [];
  var tmrIndex = tmrs.findIndex((u) => u.id === payload.id);
  draft.tmrs[tmrIndex] = payload;
  draft.openDialog = false;
};

const showDialog = (state, draft, payload) => {
  draft.openDialog = true;
};
const showDeleteDialog = (state, draft, payload) => {
  draft.openDeleteDialog = true;
};

const resetDialog = (state, draft, payload) => {
  draft.openDialog = false;
  draft.openDeleteDialog = false;
  draft.tmr_errors = [];
};

export const reducer = createReducer(initialState, {
  ...bindReducers(ActionTypes, {
    action: "deleteTmr",
    stateName: "tmr",
    async: true,
    isPaginated: false,
    successCb: tmrDeleteSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "setTmr",
    stateName: "tmr",
    async: false,
    isPaginated: false,
  }),
  ...bindReducers(ActionTypes, {
    action: "getAllTmr",
    stateName: "tmrs",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "getTmr",
    stateName: "tmr",
    async: true,
    isPaginated: false,
  }),
  ...bindReducers(ActionTypes, {
    action: "addTmr",
    stateName: "tmr",
    async: true,
    isPaginated: false,
    successCb: tmrCreatedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "editTmr",
    stateName: "tmr",
    async: true,
    isPaginated: false,
    successCb: tmrEditedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "showDeleteDialog",
    stateName: "showDeleteDialog",
    async: false,
    isPaginated: false,
    successCb: showDeleteDialog,
  }),
  ...bindReducers(ActionTypes, {
    action: "showDialog",
    stateName: "showDialog",
    async: false,
    isPaginated: true,
    successCb: showDialog,
  }),
  ...bindReducers(ActionTypes, {
    action: "resetDialog",
    stateName: "resetDialog",
    async: false,
    isPaginated: true,
    successCb: resetDialog,
  }),
});
